import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';

@Component({
    selector: 'ca-text-correction-settings',
    templateUrl: './text-correction-settings.component.html',
    styleUrls: ['./text-correction-settings.component.scss'],
    standalone: false
})
export class TextCorrectionSettingsComponent implements OnInit {
  form: FormGroup;

  private readonly prefix = 'TextCorrection';
  private readonly settingKeyEnabled = this.prefix + '.Enabled';

  constructor(
    private config: ConfigStateService,
    private fb: FormBuilder,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService
  ) {
    this.form = fb.group({
      enabled: [JSON.parse(this.config.getSetting(this.settingKeyEnabled).toLowerCase())],
    });
    this.form
      .get('enabled')
      .patchValue(JSON.parse(this.config.getSetting(this.settingKeyEnabled).toLowerCase()));
  }

  ngOnInit(): void {}

  onSubmitForm() {
    if (!this.form.valid) {
      return;
    }

    const settings: ConfigurationSettingsDto[] = [];

    settings.push({
      settingName: this.settingKeyEnabled,
      settingValue: this.form.get('enabled').value.toString(),
    });

    this.settingService.saveSetting(settings).subscribe(() => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
      );
    });
  }
}
